import { ReactComponent as DiscordLogo } from '@shared/assets/business-logos/discord-logo.svg'
import { ReactComponent as GodaddyLogo } from '@shared/assets/business-logos/godaddy-logo.svg'
import { ReactComponent as MetaLogo } from '@shared/assets/business-logos/meta-logo.svg'
import { ReactComponent as TripcomLogo } from '@shared/assets/business-logos/tripcom-logo.svg'
import { ReactComponent as UberLogo } from '@shared/assets/business-logos/uber-logo.svg'
import { ReactComponent as PlivoLogo } from '@shared/assets/illustrations/login/plivo.svg'
import { GenerativeMatter } from './generative-matter'
import './voice-ai-panel.scss'

const metrics = [
  { value: '99.99%', label: 'uptime' },
  { value: 'sub-500ms', label: 'latency' },
  { value: '20+', label: 'languages' },
]

const logos = [
  { Icon: MetaLogo, className: 'logo-meta' },
  { Icon: GodaddyLogo, className: 'logo-godaddy' },
  { Icon: UberLogo, className: 'logo-uber' },
  { Icon: DiscordLogo, className: 'logo-discord' },
  { Icon: TripcomLogo, className: 'logo-trip' },
]

/**
 * The dark left panel of the auth pages: the generative-matter artwork read as
 * an engineering plate — dot grid, corner brackets, edge rails, mono figure tags
 * and a figure strip at the foot. The chrome is drawn in hairlines and never in
 * fills, so the blob stays the subject it documents.
 */
export const VoiceAiPanel = () => (
  <aside className="vai-panel" aria-label="Plivo voice AI platform overview">
    <div className="plate-grid" aria-hidden="true" />
    <GenerativeMatter />
    <div className="gart-scrim" aria-hidden="true" />

    <div className="plate" aria-hidden="true">
      <span className="plate-c tl" />
      <span className="plate-c tr" />
      <span className="plate-c bl" />
      <span className="plate-c br" />
      <span className="plate-rail r">[ real-time voice ]</span>
      <span className="plate-rail l">fig-001</span>
    </div>

    <div className="row row-top">
      <a href="https://www.plivo.com/" aria-label="Plivo" data-testid="link-plivo-home">
        <PlivoLogo className="block h-[22px] w-auto fill-white" />
      </a>
      <span className="fig-tag">
        <b>FIG. 01</b>
        <i>cx / voice ai</i>
      </span>
    </div>

    <div className="row row-metrics">
      {metrics.map(({ value, label }) => (
        <div className="mcell" key={label}>
          <b>{value}</b>
          <span>{label}</span>
        </div>
      ))}
      <div className="mcell">
        <span className="certs">SOC 2 &middot; HIPAA &middot; GDPR</span>
        <span>compliance</span>
      </div>
    </div>

    {/* h2, not h1 — the page heading belongs to the form */}
    <div className="row row-head">
      <h2>
        Build human-like <br />
        voice AI Agents
      </h2>
    </div>

    <div className="row row-logos">
      <div className="caption">Trusted by thousands of businesses globally</div>
      <div className="logorow" aria-hidden="true">
        {logos.map(({ Icon, className }) => (
          <span className={`logo-cell ${className}`} key={className}>
            <Icon />
          </span>
        ))}
      </div>
    </div>

    <div className="row">
      <div className="plate-foot-strip">
        <span>plivo.com / cx</span>
        <span>
          end to end &middot; <b>sub-second</b>
        </span>
      </div>
    </div>
  </aside>
)
